import React, {Fragment, useState, useEffect} from "react";

import FamilyTable from "root/Tables/FamilyTable";
import './FamiliesTab.scss';

import useModalAddFamily from "../../../../../Modals/AddFamily/useModalAddFamily";
import {getChildAdoptedFamilies} from "root/DataFunctions/FamilyDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
import {useSetRecoilState} from "recoil";
import {childNameAtom} from "root/recoil/childName";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";

const FamiliesTab = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const [renderAddFamilyModal, showAddFamilyModal] = useModalAddFamily((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    useEffect(() => {
        getData();
    }, [props.child_id]);

    const getData = () =>
    {
        getChildAdoptedFamilies(props.child_id, (response) =>
        {
            setData({isLoading: false, data: getDataFromResponse(response)});
        });
    };

    //Get child's data and set the global child name used by the various body header
    const setChildName = useSetRecoilState(childNameAtom);

    useEffect(() => {
        getChildData();
    }, [props.child_id]);

    const getChildData = () =>{
        if(props.child_id !== undefined)
        {
            getChildDetails(props.child_id, (response) =>
            {
                let childData = getDataFromResponse(response)[0];
                // Set the recoil childNameAtom to the first child
                setChildName(childData.firstname + " " + childData.surname);
            });
        }
    }

    const clickHandler = (mode, family_id) =>
    {
        showAddFamilyModal(mode, props.child_id, family_id);
    }

    return (
        <Fragment>
            <div className="family-body">
                <FamilyTable child_id={props.child_id} loading={data.loading} data={data.data} clickHandler={clickHandler}/>
                <section>
                    <ActionButton icon='icon-add' onClick={() => clickHandler('create', null)} title="Add Family"/>
                </section>
            </div>

            {renderAddFamilyModal(props)}
        </Fragment>
    )
}

FamiliesTab.defaultProps = {};

export default FamiliesTab;

